// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1100":"ff5a3027","3632":"83d1f589","8313":"83d1f589","8828":"5ee54276"}[chunkId] + ".chunk.css";
};